<template>
  <div
    id="fee_payment"
    v-loading.fullscreen.lock="pageLoading"
  >
    <div class="main">
      <div class="search-description">
        <div class="description-title">
          查詢說明
        </div>
        <div class="description-content">
          最多可以選擇6個繳費期別查詢，每次查詢筆數最高為3000筆，若超過查詢上限，請調整條件分段查詢。
        </div>
      </div>
      <filter-frame
        :filter-form="paymentFilter"
        @search="getList"
        @clear="getList({})"
      />
      <div class="payment-data">
        <span class="payment-count">搜尋結果共<span>{{ paymentData.length }}</span>張繳費單</span>
        <span class="price-count">繳費金額統計(實繳/應繳)
          <span>
            {{ paymentData.reduce((a,b) => (a + parseInt(b.ActualAmount)||0),0).toLocaleString() }}
            /
            {{ paymentData.reduce((a,b) => (a + parseInt(b.ShouldAmount)||0),0).toLocaleString() }}
          </span>
        </span>
      </div>
      <div class="title_bar">
        <div class="left">
          <div class="left-left">
            <div class="choose-count">
              選取<span>{{ bill.selectionData.length }}</span>張繳費單
            </div>
          </div>
          <div class="left-right">
            <el-button
              icon="icon-calender"
              round
              :class="canChangeDate ? '':'disabled'"
              :disabled="!canChangeDate"
              @click="handleChangeDate()"
            >
              異動繳費日期
            </el-button>
            <el-button
              icon="icon-multi-open"
              round
              @click="handleSwitch(bill.selectionData,'Enable')"
            >
              啟用
            </el-button>
            <el-button
              icon="icon-multi-close"
              round
              @click="handleSwitch(bill.selectionData,'Close')"
            >
              關閉
            </el-button>
            <el-button
              icon="icon-notify"
              round
              @click="handleInformAgain(bill.selectionData)"
            >
              再通知
            </el-button>
            <el-dropdown
              trigger="click"
              @command="printPage"
            >
              <el-button
                icon="icon-print"
                round
              >
                列印
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="bill">
                  {{ $t("Fee.PrintBill") }}
                </el-dropdown-item>
                <el-dropdown-item command="receiptMultiple">
                  {{ $t("Fee.PrintReceipt") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button
              icon="icon-output"
              round
              @click="handleExportExcel()"
            >
              匯出
            </el-button>
          </div>
        </div>
        <div class="right">
          <el-button
            icon="icon-plus"
            round
            @click="handleEdit()"
          >
            新增繳費單
          </el-button>
        </div>
      </div>
      <div class="list_frame">
        <el-table
          ref="multipleTable"
          v-loading="loadingList"
          tooltip-effect="dark"
          :data="pageControl.showList"
          style="width: 100%"
          @row-click="toggleSelection"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
          />
          <el-table-column
            prop="Period"
            label="期別"
            sortable
          >
            <template slot-scope="scope">
              {{ scope.row.BillBulkName }}
            </template>
          </el-table-column>
          <el-table-column
            prop="TabletNote"
            label="戶別"
            sortable
          >
            <template slot-scope="scope">
              <router-link :to="{name: 'FeeDetailEdit',params: {'bulkid':scope.row.BillBulkId,'billid':scope.row.BillId, type: feeType }}">
                {{ scope.row.TabletNote }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="StatusText"
            label="啟用"
            width="75"
            sortable
          >
            <template slot-scope="scope">
              <div
                class="colored"
                :class="`color-${scope.row.StatusColor||'no'}`"
              >
                {{ scope.row.StatusText||'' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="ShouldAmount"
            :label="$t('Fee.BillShouldAmount')"
            align="right"
          >
            <template slot-scope="scope">
              {{ (scope.row['ShouldAmount']).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column
            prop="ActualAmount"
            :label="$t('Fee.BillActualAmount')"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row['ActualAmount'].toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column
            prop="ReceiptsPayDate"
            label="繳費日期"
            width="110"
            sortable
          >
            <span slot-scope="scope">
              <p
                v-for="(val, ind) in scope.row['ReceiptsPayDate']"
                :key="ind"
                class="multiLines"
              >
                <span>{{ val||'-' }}</span>
                <br v-if="ind !== scope.row['ReceiptsPayDate'].length - 1">
              </p>
            </span>
          </el-table-column>
          <el-table-column
            prop="ReceiptsWay"
            label="方式"
            width="130"
          >
            <span slot-scope="scope">
              <p
                v-for="(val, ind) in scope.row['ReceiptsWay']"
                :key="ind"
                class="multiLines"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="val"
                  placement="top"
                >
                  <span>{{ val||'-' }}</span>
                </el-tooltip>
                <br v-if="ind !== scope.row['ReceiptsWay'].length - 1">
              </p>
            </span>
          </el-table-column>
          <el-table-column
            prop="ReceiptsEntryDate"
            label="入帳日期"
            width="100"
          >
            <span slot-scope="scope">
              <p
                v-for="(val, ind) in scope.row['ReceiptsEntryDate']"
                :key="ind"
                class="multiLines"
              >
                <span>{{ val||'-' }}</span>
                <br v-if="ind !== scope.row['ReceiptsEntryDate'].length - 1">
              </p>
            </span>
          </el-table-column>
          <el-table-column
            prop="ReceiptsSn"
            label="銷帳編號"
            width="130"
          >
            <span slot-scope="scope">
              <p
                v-for="(val, ind) in scope.row['ReceiptsSn']"
                :key="ind"
                class="multiLines"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="val"
                  placement="top"
                >
                  <span>{{ val.length>10 ? '...'+val.slice(-10) : (val||'-') }}</span>
                </el-tooltip>
                <br v-if="ind !== scope.row['ReceiptsSn'].length - 1">
              </p>
            </span>
          </el-table-column>
          <el-table-column
            prop="ReceiptsRn"
            label="收據編號"
            width="130"
          >
            <span slot-scope="scope">
              <p
                v-for="(val, ind) in scope.row['ReceiptsRn']"
                :key="ind"
                class="multiLines"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="val"
                  placement="top"
                >
                  <span>{{ val.length>10 ? '...'+val.slice(-10) : (val||'-') }}</span>
                </el-tooltip>
                <br v-if="ind !== scope.row['ReceiptsRn'].length - 1">
              </p>
            </span>
          </el-table-column>
          <el-table-column
            prop="BillSettlementStatusName"
            label="狀態"
            width="75"
            sortable
          />
          <el-table-column
            class-name="operation"
            label="操作"
            width="315"
          >
            <template slot-scope="scope">
              <el-button
                v-if="(scope.row.BillStatusName=='未啟用'||scope.row.BillStatusName=='關閉')&&!scope.row.isBarcodeDue"
                size="mini"
                type="success"
                plain
                @click.stop="handleSwitch([scope.row],'Enable')"
              >
                啟用
              </el-button>
              <el-button
                v-if="scope.row.BillStatusName=='開啟'"
                size="mini"
                type="danger"
                plain
                @click.stop="handleSwitch([scope.row],'Close')"
              >
                關閉
              </el-button>
              <el-button
                v-if="scope.row.BillStatusName != '未啟用' && [1, 2].includes(scope.row.BillSettlementStatus)"
                size="mini"
                plain
                @click.stop="handlePay(scope.row)"
              >
                <!-- 未繳 未繳清 繳齊 溢繳--><!-- 未繳 欠繳 已繳 溢繳-->
                繳費
              </el-button>
              <el-button
                v-if="scope.row.WriteoffReceipts.length>0"
                size="mini"
                plain
                @click.stop="openReceiptSelecton(scope.row)"
              >
                收據
              </el-button>
              <el-button
                v-if="scope.row.BillStatusName=='開啟' && (+new Date() - +new Date(scope.row.StartDate) > 0) && (scope.row.BillSettlementStatus == 1 || scope.row.BillSettlementStatus == 2)"
                size="mini"
                plain
                @click="handleInformAgain([scope.row])"
              >
                再通知
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_area">
        <el-pagination
          hide-on-single-page
          :current-page="pageControl.currentPage"
          :page-sizes="[300, 500, 1000]"
          :page-size="pageControl.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paymentData.length || 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <el-dialog
      v-loading="loadingPay"
      title="繳費"
      custom-class="sm-size"
      :visible.sync="payDialog"
      :close-on-click-modal="false"
      :show-close="false"
      :lock-scroll="true"
      center
      @closed="resetForm('feePay')"
    >
      <el-form
        ref="feePay"
        :model="payData"
        status-icon
        :rules="editRule"
        @submit.native.prevent
      >
        <el-form-item label="戶別">
          {{ payData.household }}
        </el-form-item>
        <el-form-item label="應繳金額">
          {{ payData.Amount.toLocaleString() }}
        </el-form-item>
        <el-form-item
          label="實繳金額"
          prop="actualAmount"
          class="actualAmount"
        >
          <el-input
            v-model="payData.actualAmount"
            v-thousandth
            size="small"
            maxlength="9"
            :key="payDialog"
          />
        </el-form-item>
        <el-form-item label="付款方式">
          手動入帳
        </el-form-item>
        <el-form-item label="收款人">
          {{ adminName }}
          (系統自動帶入當前管理版登入者)
        </el-form-item>
        <el-form-item
          label="收據編號"
          prop="Rn"
          class="rnItem"
        >
          <span class="tip">(系統自動帶入)</span>
          <el-button
            size="mini"
            @click="payData.RnSW=true"
          >
            點此自行編號
          </el-button>
          <el-input
            v-show="payData.RnSW"
            v-model="payData.Rn"
            size="small"
            maxlength="20"
            placeholder="限20字"
          />
        </el-form-item>
        <el-form-item label="繳費日期">
          {{ payData.PayDate }}
        </el-form-item>
        <el-form-item
          label="繳費備註"
          prop="PayNote"
        >
          <el-input
            v-model="payData.PayNote"
            type="textarea"
            maxlength="50"
            :autosize="{ minRows: 2}"
            placeholder="限50字"
            resize="none"
          />
          <span class="num">{{ payData.PayNote.length || 0 }}/50</span>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="payDialog=false"
        >取消</el-button>
        <el-button
          type="primary"
          :disabled="loadingPay"
          round
          @click="savePay('feePay')"
        >確定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="printReceiptDialog"
      title="列印收據"
      :show-close="false"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
    >
      <el-table
        :data="receipt.rowData.WriteoffReceipts"
        @selection-change="(val)=>{receipt.selection=val.map(v=>v.ReceiptId)}"
      >
        <el-table-column
          type="selection"
          width="55"
        />
        <el-table-column
          width="80"
          property="Amount"
          :label="$t('Fee.BillActualAmount')"
          align="right"
        >
          <template slot-scope="scope">
            {{ scope.row.Amount.toLocaleString() }}
          </template>
        </el-table-column>
        <el-table-column
          width="80"
          property="HandlingFee"
          label="手續費"
          align="right"
        />
        <el-table-column
          width="100"
          property="ReceiptWayName"
          label="方式"
        />
        <el-table-column
          width="100"
          property="ManualWriteoffHandler"
          label="收款人"
        >
          <span slot-scope="scope">
            {{ scope.row.ManualWriteoffHandler || '-' }}
          </span>
        </el-table-column>
        <el-table-column
          width="120"
          property="PayDate"
          label="繳費日期"
        />
        <el-table-column
          width="120"
          property="ActualEntryDate"
          label="入帳日期"
        />
        <el-table-column
          property="WriteoffSn"
          label="銷帳編號"
        />
      </el-table>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="printReceiptDialog=false"
        >取消</el-button>
        <el-button
          type="success"
          round
          @click="printPage('receipt');"
        >
          確定
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="isShowChangeDateDialog"
      title="繳費日期異動"
      :show-close="true"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
    >
      <div :class="changeDateIsEdit ? '' : 'change-date-dialog-content'">
        <div v-if="!changeDateIsEdit">
          繳費資訊
        </div>
        <el-form
          ref="changeDate"
          :model="changeDateData"
          :rules="changeDateIsEdit ? changeDateRule : {}"
          status-icon
          @submit.native.prevent
        >
          <el-form-item
            label="戶別代碼"
            prop="households"
            class="householad-tags-container"
          >
            <el-tag
              v-for="household in changeDateData.households"
              :key="household.TabletId"
              :closable="changeDateIsEdit && changeDateData.households.length > 1"
              @close="handleHouseholdTagClose(household)"
            >
              {{ household.TabletNote }}
            </el-tag>
          </el-form-item>
          <el-form-item
            label="繳費起迄日"
            prop="rangeDate"
            class="date-range-container"
          >
            <el-date-picker
              v-if="changeDateIsEdit"
              v-model="changeDateData.rangeDate"
              value-format="yyyy/MM/dd"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期"
              :picker-options="dueDatePickerOptions"
            />
            <div v-else>
              {{ $formatDate(changeDateData.rangeDate[0]) }} 至 {{ $formatDate(changeDateData.rangeDate[1]) }}
            </div>
          </el-form-item>
          <el-form-item
            label="條碼到期日"
            prop="barcodeEndDate"
            class="date-container"
          >
            <el-date-picker
              v-if="changeDateIsEdit"
              v-model="changeDateData.barcodeEndDate"
              value-format="yyyy/MM/dd"
              type="date"
              :picker-options="dueDatePickerOptions"
            />
            <div v-else>
              {{ $formatDate(changeDateData.barcodeEndDate) }}
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="!changeDateIsEdit">
        註 : 戶別繳費日期已完成更新，您可以點選下方進行繳費再通知及列印繳費單。
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <template v-if="changeDateIsEdit">
          <el-button
            round
            @click="isShowChangeDateDialog=false"
          >取消</el-button>
          <el-button
            type="success"
            round
            @click="changeDate();"
          >
            確定
          </el-button>
        </template>
        <template v-else>
          <el-button
            icon="icon-notify"
            round
            @click="informAgain(changeSuccessHouseholds)"
          >
            再通知
          </el-button>
          <el-button
            icon="icon-print"
            round
            @click="printPage('changeDate')"
          >
            {{ $t("Fee.Print") }}
          </el-button>
        </template>
      </span>
    </el-dialog>
    <print-bill-frame ref="printbill" />
    <print-receipt-frame ref="printreceipt" />
  </div>
</template>
<script>
import filterFrame from '@/components/FilterFrame'
import PrintBillFrame from '@/components/PrintBillFrame'
import PrintReceiptFrame from '@/components/PrintReceiptFrame'
import { checkPaymentDate, checkBarcodeDate } from '@/js/utils/fee'
export default {
  components: {
    'filter-frame': filterFrame,
    'print-bill-frame': PrintBillFrame,
    'print-receipt-frame': PrintReceiptFrame
  },
  props: {
    periodDataNew: Number, // 最新期別
    configData: Object
  },
  data () {
    const validateRn = (rule, value, callback) => {
      const pattern = new RegExp(/^[A-Za-z0-9\-]+$/)
      if (value.toString().length === 0) {
        callback()
      } else if (!value.toString().match(pattern)) {
        callback(new Error('限輸入英文、數字 、" - "'))
      } else {
        callback()
      }
    }
    const validateBarcodeDue = (rule, value, callback) => {
      const endDate = this.changeDateData.rangeDate ? this.changeDateData.rangeDate[1] : 0
      callback(checkBarcodeDate(value, endDate))
    }
    const validateRangeDate = (rule, value, callback) => {
      if (value && value[0] && value[1]) {
        callback(checkPaymentDate(value[0], value[1]))
      } else {
        callback()
      }
    }
    return {
      pageLoading: false,
      loadingList: false,
      loadingPay: false,
      filterCondition: null,
      pageControl: {
        pageSize: 300,
        currentPage: 1,
        total: 0,
        showList: []
      },
      bill: { // 列表checkbox 已選擇資料
        selection: [],
        selectionData: []
      },
      receipt: { // 收據列印選擇及資料
        selection: [],
        rowData: []
      },
      periodData: [],
      periodIds: [this.$route.params.id || this.periodDataNew || 0],
      payDialog: false,
      printReceiptDialog: false,
      isShowChangeDateDialog: false,
      changeDateIsEdit: true,
      canChangeDate: false,
      payData: {
        household: '',
        Amount: 0,
        actualAmount: 0,
        ReceiptWay: '',
        Rn: '',
        PayDate: '',
        EntryDate: '',
        PayNote: '',
        id: 0,
        RnSW: false
      },
      changeDateData: {
        households: [],
        rangeDate: [],
        barcodeEndDate: ''
      },
      editRule: {
        BillBulkName: [
          { required: true, message: '請輸入名稱', trigger: 'change' }
        ],
        actualAmount: [
          { required: true, message: '請輸入金額', trigger: 'change', pattern: /^\+?[1-9][0-9,]*$/ }
        ],
        Rn: [
          { validator: validateRn, trigger: 'change' }
        ]
        // ReceiptWay: [
        //   { required: true, message: '請選擇付款方式', trigger: 'change' }
        // ],
      },
      changeDateRule: {
        rangeDate: [
          { required: true, message: '請選擇繳費起迄日', trigger: 'change' },
          { validator: validateRangeDate, trigger: 'change' }
        ],
        barcodeEndDate: [
          { required: true, message: '請選擇條碼到期日', trigger: 'change' },
          { validator: validateBarcodeDue, trigger: 'change' }
        ]
      },
      changeSuccessHouseholds: [],
      paymentFilter: [
        {
          label: '繳費期別',
          name: 'period',
          type: 'multiselectLimit',
          options: null,
          value: '',
          limit: 6
        },
        {
          label: '繳費狀態',
          name: 'state',
          type: 'select',
          options: [
            {
              label: '請選擇',
              value: ''
            },
            {
              label: '未繳',
              value: 1
            },
            {
              label: '欠繳',
              value: 2
            },
            {
              label: '已繳',
              value: 3
            },
            {
              label: '溢繳',
              value: 4
            }
          ],
          value: ''
        },
        {
          label: '戶別',
          name: 'household',
          type: 'house',
          value: ''
        },
        {
          label: '繳費起訖',
          name: 'payDate',
          type: 'date'
        },
        {
          label: '繳費方式',
          name: 'payType',
          type: 'multiselect',
          options: [],
          value: []
        },
        // {
        //   label: '帳單編號',
        //   name: 'billNum',
        //   type: 'input',
        //   value: '',
        // },
        {
          label: '銷帳編號',
          name: 'billoffNum',
          type: 'input',
          value: ''
        },
        {
          label: '入帳起訖',
          name: 'entryDate',
          type: 'date'
        },
        {
          label: '開通狀態',
          name: 'activeState',
          type: 'select',
          options: [
            {
              label: '請選擇',
              value: ''
            },
            {
              label: '已開通',
              value: 1
            },
            {
              label: '未開通',
              value: 2
            }
          ],
          value: ''
        },
        {
          label: '收據編號',
          name: 'receiptNum',
          type: 'input',
          value: ''
        }
      ],
      paymentList: [
        {
          // fixed: true,
          width: '55',
          type: 'selection'
        },
        // {
        //   prop: 'TabletNote',
        //   label: '戶別',
        //   width: '100',
        //   sortable: true
        // },
        {
          slot: 'tabletNote'
        },
        // {
        //   slot:'periodName'
        // },
        // {
        //   prop: 'BillCreateDate',
        //   label: '建立日期',
        //   width: '105',
        //   sortable: true
        // },
        {
          prop: 'StatusText',
          label: '啟用',
          width: '75',
          sortable: true,
          component: 'colored'
        },
        // {
        //   prop: 'push',
        //   label: '推播',
        //   width: '80',
        //   sortable: true,
        // },
        {
          prop: 'BillShouldAmount',
          label: '應繳',
          width: '70',
          align: 'right'
        },
        {
          prop: 'BillActualAmount',
          label: '實繳',
          width: '70',
          align: 'right'
        },
        {
          prop: 'ReceiptsPayDate',
          label: '繳費日期',
          width: '100',
          component: 'multi-lines'
        },
        {
          prop: 'ReceiptsWay',
          label: '方式',
          width: '130',
          tooltip: true,
          component: 'multi-lines'
        },
        {
          prop: 'ReceiptsEntryDate',
          label: '入帳日期',
          width: '100',
          component: 'multi-lines'
        },
        {
          prop: 'ReceiptsSn',
          label: '銷帳編號',
          width: '135',
          tooltip: true,
          snshorten: true,
          component: 'multi-lines'
        },
        {
          prop: 'ReceiptsRn',
          label: '收據編號',
          width: '135',
          tooltip: true,
          snshorten: true,
          component: 'multi-lines'
        },
        {
          prop: 'BillSettlementStatus',
          label: '狀態',
          width: '75',
          sortable: true
        },
        {
          slot: 'Operation'
        }
      ],
      paymentData: [],
      adminName: '',
      dueDatePickerOptions: {
        disabledDate: this.getDisabledDate
      },
      feeType: 'management'
    }
  },
  watch: {
    periodData (list) {
      this.getPeriodSelectList()
      this.getList()
    },
    'bill.selectionData' (item) {
      this.bill.selection = item.map(v => v.BillId)
    },
    periodDataNew (newPeriod) {
      console.log(newPeriod)
      console.log(!this.$route.params.id)
      if (!this.$route.params.id) {
        this.$router.push({ name: 'FeePaymentList', params: { id: newPeriod, type: this.feeType } })
      }
      this.getPeriodSelectList()
    }
  },
  mounted () {
    this.getBillBulkBasicList()
    this.getList()
    this.getPeriodSelectList()
    this.getPayWay()
    if (JSON.parse(localStorage.getItem('loginUserInfo'))?.AdminName) this.adminName = JSON.parse(localStorage.getItem('loginUserInfo')).AdminName
    this.feeType = this.$route.params.type
  },
  methods: {
    getBillBulkBasicList () { // 篩選期別 - 取得期別列表選單
      apiBillservice.BillBulk.GetBillBulkBasicList().then((res) => {
        this.periodData = res.data.Data
      }).catch((err) => {
        this.$message({
          message: '取得期別資料失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
        this.loadingList = false
      })
    },
    getList (condition) { // 取得繳費單列表
      if (condition) {
        this.filterCondition = _cloneDeep(condition)
      }
      let requestFunction = null
      if (this.filterCondition && this.filterCondition.period) { // 有篩選的期別
        this.periodIds = this.filterCondition.period
      } else { // 無篩選的期別
        this.periodIds = [Number(this.$route.params.id) || Number(this.periodDataNew) || 0]
      }
      const isMorePeriod = this.periodIds.length > 1

      let requestData = { BillBulkIds: this.periodIds }
      if (isMorePeriod) requestData.MaxCount = 3000
      if (this.periodIds.length > 0) {
        const tempRequestData = this.filterCondition
          ? Object.assign({},
            this.filterCondition.payDate && { 'PaymentDateFilter.StartDate': this.filterCondition.payDate[0] },
            this.filterCondition.payDate && { 'PaymentDateFilter.EndDate': `${this.filterCondition.payDate[1]} 23:59:59` },
            this.filterCondition.entryDate && { 'EntryDateFilter.StartDate': this.filterCondition.entryDate[0] },
            this.filterCondition.entryDate && { 'EntryDateFilter.EndDate': `${this.filterCondition.entryDate[1]} 23:59:59` },
            this.filterCondition.state && { BillSettlementStatus: this.filterCondition.state },
            this.filterCondition.activeState && { CommunityActivatedStatus: this.filterCondition.activeState },
            this.filterCondition.payType && { ReceiptWays: this.filterCondition.payType },
            this.filterCondition.household && { TabletId: this.filterCondition.household.TabletId },
            this.filterCondition.billoffNum && { WriteoffSn: this.filterCondition.billoffNum },
            this.filterCondition.receiptNum && { ReceiptNumber: this.filterCondition.receiptNum }
          )
          : {}
        requestData = { ...requestData, ...tempRequestData }
        requestFunction = () => apiBillservice.Bill.GetBillList(requestData)
      } else {
        this.paymentData = []
        this.currentChangePage(this.paymentData, this.pageControl.currentPage)
        console.log('periodIds=0')
        return
      }
      console.log(requestData)

      const chosePeriod = this.periodData.find((item) => this.periodIds.includes(item.BillBulkId))
      // eslint-disable-next-line eqeqeq
      if (chosePeriod == undefined || chosePeriod.BillBulkStatus === 2 || this.periodIds.length > 1) this.canChangeDate = false
      else this.canChangeDate = true

      this.loadingList = true
      requestFunction().then((res) => {
        const responseData = res.data.Data.Bills
        this.paymentData = responseData.map((e) => {
          e.isBarcodeDue = new Date().getTime() - new Date(e.BarcodeDate).getTime() > 0
          e.WriteoffReceipts = e.WriteoffReceipts.map(val => {
            val.HandlingFeeDisplay = `${val.ConfigHandlingFeeModeShowName != null ? val.ConfigHandlingFeeModeShowName : ''} ${val.HandlingFee != null ? val.HandlingFee : ''}`
            val.PayDate = this.$formatDate(val.PayTime)
            val.EntryDate = this.$formatDate(val.EntryDate)
            val.ActualEntryDate = this.$formatDate(val.ActualEntryDate)
            return val
          })
          e.StartDate = this.$formatDate(e.StartDate)
          e.DueDate = this.$formatDate(e.DueDate)
          e.BarcodeDate = this.$formatDate(e.BarcodeDate)
          e.ReceiptsSn = e.WriteoffReceipts.map(val => val.WriteoffSn)
          e.ReceiptsRn = e.WriteoffReceipts.map(val => val.ReceiptNumber)
          e.ReceiptsWay = e.WriteoffReceipts.map(val => `${val.ReceiptWayName}(${val.Amount.toLocaleString()})`)
          e.ManualWriteoffHandler = e.WriteoffReceipts.map(val => val.ManualWriteoffHandler)
          e.ReceiptsPayDate = e.WriteoffReceipts.map(val => this.$formatDate(val.PayTime))
          e.ReceiptsEntryDate = e.WriteoffReceipts.map(val => this.$formatDate(val.ActualEntryDate))
          e.BillBulkName = e.BillBulkName ? e.BillBulkName : this.periodData.find(item => item.BillBulkId === this.periodIds[0])?.Name
          e.BillBulkId = e.BillBulkId ? e.BillBulkId : this.periodData.find(item => item.BillBulkId === this.periodIds[0])?.BillBulkId
          const name = this.periodData.filter(val => {
            if (this.periodIds.includes(val.BillBulkId)) {
              return val.Name
            }
          }).map(val => val.Name)
          e.periodName = name[0] || ''
          switch (e.BillStatusName) {
            case '未啟用':
              e.StatusColor = 'danger'
              e.StatusText = '未啟用'
              break
            case '開啟':
              e.StatusColor = 'success'
              e.StatusText = (+new Date(e.StartDate) > +new Date()) ? '待發佈' : '繳費中'
              break
            case '關閉':
              e.StatusText = '已關閉'
              break
            default:
              e.StatusText = ''
          }

          return e
        })
        this.currentChangePage(this.paymentData, this.pageControl.currentPage)
        console.log(this.paymentData)
        this.loadingList = false
      }).catch((err) => {
        this.$message({
          message: '取得繳費列表失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
        this.loadingList = false
      })
    },
    getPeriodSelectList () { // 篩選期別 - 取得期別列表選單
      if (!_isEmpty(this.periodData)) {
        const list = this.periodData.map((e) => {
          const item = {
            label: e.Name,
            value: e.BillBulkId,
            id: e.BillBulkId
          }
          return item
        })
        this.paymentFilter.map(val => {
          // eslint-disable-next-line eqeqeq
          if (val.name == 'period') {
            val.options = [...list]
            val.value = list.find((item) => this.periodIds.includes(item.value)) ? [parseInt(this.periodIds)] : []
            return val
          }
        })
      }
    },
    getPayWay () { // 篩選付款方式 - 取得付款方式
      apiBillservice.Receipt.GetReiptWay(
      ).then((res) => {
        const payOption = res.data.Data.map((val, ind) => {
          return {
            label: val.Way,
            value: val.EnumWay,
            id: val.BillId
          }
        })
        this.paymentFilter.map((val, ind) => {
          // eslint-disable-next-line eqeqeq
          if (val.name == 'payType') {
            console.log(val.options)
            val.options = _cloneDeep(payOption)
          }
        })
      }).catch((err) => {
        this.$message({
          message: '取得付款方式失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
      })
    },
    changeDate () { // 繳費日期異動
      this.$refs.changeDate.validate((valid) => {
        if (valid) {
          console.log(this.changeDateData)
          this.putChangeDate()
        } else {
          this.$message({
            showClose: true,
            message: '繳費資訊 - 請確認所有必填欄位已填妥',
            type: 'warning'
          })
        }
      })
    },
    putChangeDate () {
      const requestData = {
        Ids: this.changeDateData.households.map((item) => item.BillId),
        StartDate: `${this.changeDateData.rangeDate[0]} 00:00:00`,
        DueDate: `${this.changeDateData.rangeDate[1]} 23:59:59`,
        BarcodeDate: `${this.changeDateData.barcodeEndDate} 23:59:59`
      }
      apiBillservice.Bill.PutBillDate(
        requestData
      ).then((res) => {
        this.changeDateIsEdit = false
        this.changeSuccessHouseholds = res.data.Data?.Succeed
        if (res.data.Data.Succeed?.length <= 0) {
          this.$message({
            showClose: true,
            message: '勾選戶別無法異動日期，可能情境為已關閉或已繳費，請重新勾選',
            type: 'warning'
          })
          this.isShowChangeDateDialog = false
        } else {
          this.$message({
            showClose: true,
            message: '繳費日期異動完成',
            type: 'success'
          })
        }
        this.getList()
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: err,
          type: 'warning'
        })
      })
    },
    handleHouseholdTagClose (household) { // 移除用戶標籤
      // eslint-disable-next-line eqeqeq
      const index = this.changeDateData.households.findIndex((item) => item.TabletId == household.TabletId)
      console.log(household, index)
      if (index >= 0) this.changeDateData.households.splice(index, 1)
    },
    async handleChangeDate () { // 開啟異動繳費日期彈窗
      if (this.bill.selectionData.length <= 0) {
        this.$message({
          message: '請勾選欲異動繳費日期戶別',
          type: 'warning'
        })
        return
      }
      const notPayHouseholds = this.bill.selectionData.filter((item) => item.BillSettlementStatus === 1 && item.BillStatusName !== '關閉')
      if (notPayHouseholds.length <= 0) {
        this.$message({
          message: '勾選戶別無法異動日期，可能情境為已關閉或已繳費，請重新勾選',
          type: 'warning'
        })
        return
      }
      if (notPayHouseholds.length < this.bill.selectionData.length) {
        try {
          const goNextStep = await this.$confirm(`勾選${this.bill.selectionData.length}筆繳費單中，有${this.bill.selectionData.length - notPayHouseholds.length}筆繳費單因已關閉或已繳費不可異動，點選確認繼續異動繳費單`, '提示', {
            confirmButtonText: '確認',
            cancelButtonText: '取消',
            roundButton: true,
            type: 'success',
            closeOnClickModal: false
          })
          if (!goNextStep) return
        } catch (e) {
          return
        }
      }
      this.changeDateIsEdit = true
      this.changeDateData.households = notPayHouseholds
      this.changeDateData.rangeDate = [
        notPayHouseholds[0].StartDate.replaceAll('-', '/').replace(/\d{2}:\d{2}:\d{2}/, '').trim(),
        notPayHouseholds[0].DueDate.replaceAll('-', '/').replace(/\d{2}:\d{2}:\d{2}/, '').trim()
      ]
      this.changeDateData.barcodeEndDate = notPayHouseholds[0].BarcodeDate.replaceAll('-', '/').replace(/\d{2}:\d{2}:\d{2}/, '').trim()
      this.isShowChangeDateDialog = true
    },
    handleEdit (item) { // 前往繳費單編輯頁面
      // eslint-disable-next-line eqeqeq
      const allPeriod = this.paymentFilter.find((item) => item.name == 'period').options
      this.$router.push(
        {
          name: 'FeeDetailEdit',
          params: {
            bulkid: allPeriod && allPeriod[0] ? allPeriod[0].id : '',
            billid: 0,
            type: this.feeType
          }
        })
    },
    handleSwitch (itemArr, action) { // 繳費單開關
      console.log(itemArr)
      if (itemArr && itemArr.length > 0) {
        this.pageLoading = true
        // eslint-disable-next-line eqeqeq
        const processeditemArr = itemArr.filter((v) => { return (v.BillStatusName == '開啟') || ((v.BillStatusName == '未啟用' || v.BillStatusName == '關閉') && (!v.isBarcodeDue)) }) // 過濾已過條碼到期日項目不能開啟
        console.log(processeditemArr)
        const itemIdArr = processeditemArr.map((v) => { return v.BillId })
        // eslint-disable-next-line eqeqeq
        const openedBill = processeditemArr.filter((v) => { return v.BillStatusName == '開啟' })
        const openedBillIdArr = openedBill.map((v) => { return v.BillId })
        // eslint-disable-next-line eqeqeq
        const closedBill = processeditemArr.filter((v) => { return v.BillStatusName == '關閉' && (!v.isBarcodeDue) })
        // eslint-disable-next-line eqeqeq
        const undoBill = processeditemArr.filter((v) => { return v.BillStatusName == '未啟用' && (!v.isBarcodeDue) })
        console.log(openedBill.length, closedBill.length, undoBill.length)
        const queryPath = {
          billStatusEnum: action
        }
        const requestData = {
          Ids: []
        }
        // eslint-disable-next-line eqeqeq
        if (action == 'Enable') {
          requestData.Ids = _cloneDeep(itemIdArr)
        }
        // eslint-disable-next-line eqeqeq
        if (action == 'Close') {
          requestData.Ids = _cloneDeep(openedBillIdArr)
        }
        apiBillservice.Bill.PutMultiBillStatus(
          queryPath,
          requestData
        ).then((res) => {
          console.log(res)
          this.pageLoading = false
          let actionText = ''
          // eslint-disable-next-line eqeqeq
          if (action == 'Enable') { actionText = `啟用${closedBill.length + undoBill.length}筆` }
          // eslint-disable-next-line eqeqeq
          if (action == 'Close') { actionText = `關閉${openedBill.length}筆` }
          this.$message({
            message: `已成功${actionText}繳費單`,
            type: 'warning'
          })
          this.getList()
        }).catch((err) => {
          this.pageLoading = false
          this.$message({
            message: '繳費單狀態改變失敗，請稍後再試',
            type: 'warning'
          })
          console.log(err.response)
        })
      } else {
        let actionText = ''
        // eslint-disable-next-line eqeqeq
        if (action == 'Open') { actionText = '啟用' }
        // eslint-disable-next-line eqeqeq
        if (action == 'Closed') { actionText = '關閉' }
        this.$message({
          message: `請勾選欲${actionText}戶別`,
          type: 'warning'
        })
      }
    },
    handleInformAgain (itemArr) {
      console.log(itemArr)
      if (itemArr && itemArr.length > 0) {
        this.pageLoading = true
        // eslint-disable-next-line eqeqeq
        const processeditemArr = itemArr.filter(v => (v.BillStatusName == '開啟') && ((+new Date() - +new Date(v.StartDate)) > 0) && ((v.BillSettlementStatus == 1 || v.BillSettlementStatus == 2))) // 過濾非開啟或已開啟未到繳費起日的項目 且為未繳及欠繳
        console.log(processeditemArr)
        const itemIdArr = processeditemArr.map(v => v.BillId)
        if (processeditemArr.length === 0) {
          this.pageLoading = false
          this.$message({
            message: `已成功再通知提醒${processeditemArr.length}筆繳費單盡快繳款`,
            type: 'warning'
          })
          return
        }
        const requestData = _cloneDeep(itemIdArr)
        this.informAgain(requestData)
      } else {
        this.$message({
          message: '請勾選欲再通知戶別',
          type: 'warning'
        })
      }
    },
    informAgain (billIds) {
      const requestData = {
        Ids: _cloneDeep(billIds)
      }
      apiBillservice.Bill.PutNotificationAgain(
        requestData
      ).then((res) => {
        console.log(res)
        this.pageLoading = false
        this.$message({
          message: `已成功再通知提醒${billIds.length}筆繳費單盡快繳款`,
          type: 'warning'
        })
      }).catch((err) => {
        this.pageLoading = false
        this.$message({
          message: '再通知失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
      })
    },
    handlePay (item) { // 點擊繳費
      this.payData.RnSW = false
      this.payDialog = true
      console.log(item)
      this.payData.Amount = item.DiffAmount * (-1)
      this.payData.actualAmount = this.payData.Amount
      this.payData.household = item.TabletNote
      this.payData.id = item.BillId
      this.payData.PayDate = this.$formatDate(new Date())
      this.payData.BillBulkId = item.BillBulkId
    },
    savePay (formName) { // 確定繳費
      this.loadingPay = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const queryPath = {
            billBulkId: this.payData.BillBulkId,
            billId: this.payData.id
          }
          const requestData = {
            Rn: this.payData.Rn,
            Amount: Number.isInteger(this.payData.actualAmount) ? this.payData.actualAmount : parseInt(this.payData.actualAmount.replaceAll(',', '')) || 0,
            PayDate: this.payData.PayDate,
            EntryDate: this.payData.EntryDate,
            Note: this.payData.PayNote,
            // "ReceiptWay": this.payData.ReceiptWay,
            ReceiptWay: 'CashManual'
          }
          apiBillservice.BillBulk.PostWriteoffManual(
            queryPath,
            requestData
          ).then((res) => {
            console.log(res.data)
            this.payDialog = false
            this.loadingPay = false
            this.$confirm('繳費成功，是否列印收據?', '提示', {
              confirmButtonText: '列印',
              cancelButtonText: '取消',
              roundButton: true,
              type: 'success',
              closeOnClickModal: false
            }).then(() => {
              this.getList()
              this.$refs.printreceipt.getReceiptData(this.payData.BillBulkId, this.payData.id, { receiptIds: [res.data.Data] })
            }).catch(() => {
              this.getList()
            })
          }).catch((err) => {
            this.$message({
              message: '繳費失敗，請稍後再試',
              type: 'warning'
            })
            console.log(err.response)
            this.loadingPay = false
          })
        } else {
          this.loadingPay = false
          this.$message({
            showClose: true,
            message: '繳費失敗 - 請確認各欄位均已填妥',
            type: 'warning'
          })
          return false
        }
      })
    },
    printPage (page, item) { // 列印繳費單 bill receipt
      console.log(item)
      // eslint-disable-next-line eqeqeq
      if (page == 'bill') { // 列印繳費單
        if (this.bill.selection.length > 0) {
          const billNoPrice = this.bill.selectionData.filter((val, ind) => {
            if (val.BillShouldAmount <= 0) {
              return val
            }
          })
          const billNotActive = this.bill.selectionData.filter((val, ind) => {
            // eslint-disable-next-line eqeqeq
            if (val.BillStatusName == '未啟用') {
              return val
            }
          })
          const billNoPriceNotActive = this.bill.selectionData.filter((val, ind) => {
            // eslint-disable-next-line eqeqeq
            if (val.BillShouldAmount <= 0 && val.BillStatusName == '未啟用') {
              return val
            }
          })
          if (billNoPrice.length > 0 || billNotActive.length > 0) {
            // let billNoPriceString = billNoPrice.length>0 ? `應繳金額小於零：${billNoPrice.map(val=>val.TabletNote).join('/')}<br>` : ''
            // let billNotActiveString = billNotActive.length>0 ? `未啟用：${billNotActive.map(val=>val.TabletNote).join('/')}<br>` : ''
            const confirmText = `您選取的繳費單有[${billNoPrice.length + billNotActive.length - billNoPriceNotActive.length}]筆為「未啟用」或「應繳總金額為負或0」的繳費單，紙本繳費單上會加上範本浮水印，請確認是否仍要列印？`
            this.$confirm(confirmText, '提示', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '確定列印',
              cancelButtonText: '取消',
              roundButton: true,
              type: 'warning',
              closeOnClickModal: false
            }).then(() => {
              this.$refs.printbill.getBillData(this.periodIds, this.bill.selection)
            }).catch(() => {

            })
          } else {
            this.$refs.printbill.getBillData(this.periodIds, this.bill.selection)
          }
        } else {
          this.$message({
            message: '請勾選欲列印的繳費單',
            type: 'warning'
          })
        }
      // eslint-disable-next-line eqeqeq
      } else if (page == 'receipt') { // 列印收據
        if (this.receipt.selection.length > 0) {
          this.$refs.printreceipt.getReceiptData(this.receipt.rowData.BillBulkId, this.receipt.rowData.BillId, { receiptIds: this.receipt.selection })
          this.printReceiptDialog = false
        } else {
          this.$message({
            message: '請勾選欲列印的收據',
            type: 'warning'
          })
        }
      } else if (page === 'changeDate') { // 繳費日期異動繳費單
        if (this.changeSuccessHouseholds.length > 0) {
          this.$refs.printbill.getBillData(this.periodIds, this.changeSuccessHouseholds)
        }
      } else if (page === 'receiptMultiple') { // 批次列印收據
        if (this.bill.selection.length <= 0) {
          this.$message({
            message: this.$t('Fee.PleaseChooseBill'),
            type: 'warning'
          })
          return false
        }
        const selectionBill = this.pageControl.showList.filter((item) => this.bill.selection.includes(item.BillId))
        const haveReceipt = selectionBill.some((item) => item.WriteoffReceipts && item.WriteoffReceipts.length > 0)
        if (!haveReceipt) {
          this.$message({
            message: this.$t('Fee.BillNoReceipt'),
            type: 'warning'
          })
          return false
        }
        this.$refs.printreceipt.getMultipleReceiptData(this.bill.selection)
      }
    },
    openReceiptSelecton (item) { // 開啟選擇列印收據對話框
      this.receipt.rowData = _cloneDeep(item)
      this.receipt.selection.length = 0
      this.printReceiptDialog = true
    },
    handleExportExcel () { // 下載excel
      if (this.bill.selection.length > 0) {
        console.log(this.bill.selection)
        this.pageLoading = true
        const requestData = {
          Ids: this.bill.selection
        }
        const config = {
          responseType: 'blob' // important
        }
        apiBillservice.Bill.GetBillExport(
          requestData,
          config
        ).then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          // link.setAttribute('download',`${row.BillBulkName}_${this.getNowDate()}.xlsx`) //or any other extension
          link.setAttribute('download', `${decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('=')[1].replace(/"/g, ''))}`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.pageLoading = false
        }).catch((err) => {
          console.log(err)
          console.log(err.response)
          this.$message({
            message: '匯出的繳費單失敗，請稍後再試',
            type: 'warning'
          })
          this.pageLoading = false
        })
      } else {
        this.$message({
          message: '請勾選欲匯出的繳費單戶別',
          type: 'warning'
        })
      }
    },
    getNowDate () { // 取得當前日期 ex.03/22
      const now = new Date()
      const formatNow = this.$formatDate(now)
      const stringNOw = formatNow.split('/')[1] + formatNow.split('/')[2]
      return stringNOw
    },
    resetForm (formName) { // 重置表格資料
      this.$refs[formName].resetFields()
    },
    handleSizeChange (pageSize) { // 頁面行數切換
      this.pageControl.pageSize = pageSize
      this.handleCurrentChange(this.pageControl.currentPage)
    },
    handleCurrentChange (currentPage) { // 頁碼切換
      this.pageControl.currentPage = currentPage
      this.currentChangePage(this.paymentData, currentPage)
    },
    currentChangePage (list, currentPage) { // 分頁方法
      let from = (currentPage - 1) * this.pageControl.pageSize
      const to = currentPage * this.pageControl.pageSize
      this.pageControl.showList = []
      for (; from < to; from++) {
        if (list[from]) {
          this.pageControl.showList.push(list[from])
        }
      }
    },
    toggleSelection (row) {
      console.log(row)
      if (row) {
        this.$refs.multipleTable.toggleRowSelection(row)
      }
    },
    handleSelectionChange (val) { // checkbox選擇變更
      console.log(val)
      this.bill.selectionData = _cloneDeep(val)
    },
    getDisabledDate (e) {
      return dayjs(e).isAfter(dayjs().add(365, 'day'), 'date')
    }
  }
}
</script>
<style lang="sass" scoped>
.disabled
  opacity: 0.3
  background: #fafafa !important
  border: solid 1px #666 !important
  border-color: #666 !important
  color: #333 !important
#fee_payment
  text-align: center
  ::v-deep .el-dialog
    +basicDialog
    .rnItem
      span.tip
        color: $dangerColor
      .el-button
        margin: 0 10px 10px
    .actualAmount
      display: flex
      .el-form-item__content
        flex: 1
  ::v-deep .el-table
    +basicTable
    .colored
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
      &.color-success
        color: $mainColor
      &.color-danger
        color: $dangerColor
    .multiLines
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
  .main
    min-width: 900px
    color: $mainFontColor
    .search-description
      display: flex
      padding: 15px 10px
      .description-title
        margin-right: 20px
        font-weight: bold

    .payment-data
      margin: 20px 0
      text-align: left
      .payment-count
        font-size: 20px
        font-weight: bold
        span
          color: $mainColor
          padding-inline: 10px
      .price-count
        margin-top: 10px
        margin-left: 10px
        font-size: 14px
        text-align: left
        span
          color: $mainColor
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 20px 0
      .left
        display: flex
        justify-content: space-between
        align-items: center
        width: 100%
        border: 1px solid #000
        border-radius: 10px
        padding: 20px
      .left-right
        span
          margin: 0 20px
          color: $mainFontColor
          vertical-align: middle
        .el-dropdown + .el-button,
        .el-button + .el-dropdown
          margin-left: 10px
      .right
        padding-inline: 20px
        span
          margin: 0 20px
          color: $mainFontColor
          vertical-align: middle
    .el-button + .receiptBtn
      .el-button
        margin-left: 10px
    .pagination_area
      padding: 20px 0
.receiptPrintOperation
  text-align: right
  padding-top: 15px
.householad-tags-container,
.date-range-container,
.date-container
  ::v-deep .el-form-item__content
    width: calc(100% - 127px)
    margin-left: auto
    max-height: 115px

.householad-tags-container
  ::v-deep .el-form-item__content
      overflow-y: auto
.date-range-container,
.date-container
  ::v-deep .el-date-editor
    width: 100%
::v-deep .el-select
  .el-tag
    display: flex
    align-items: center
    .el-select__tags-text
      display: inline-block
      max-width: 190px
      overflow: hidden
      text-overflow: ellipsis
.change-date-dialog-content
  display: flex
  & > div
    white-space: nowrap
    padding-top: 6px
    padding-right: 20px
</style>
